import { Routes } from "@angular/router";
import { AuthGuard } from "./auth.guard";
import { RoleGuard } from "./role.guard";

export const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./layouts/blank-layout/blank-layout.routes").then(
        (m) => m.BLANK_ROUTES
      ),
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./layouts/auth-layout/auth-layout.routes").then(
        (m) => m.AUTH_ROUTES
      ),
  },
  {
    path: "admin",
    loadChildren: () =>
      import(
        "./layouts/internal-layout/internal-superadmin-layout.routes"
      ).then((m) => m.INTERNAL_ROUTES_SUPER_ADMIN),
    canActivate: [AuthGuard, RoleGuard], // only super_admin can access
  },
  {
    path: "app",
    loadChildren: () =>
      import("./layouts/internal-layout/internal-layout.routes").then(
        (m) => m.INTERNAL_ROUTES
      ),
    canActivate: [AuthGuard], // Protect this route
  },
  {
    path: "",
    loadChildren: () =>
      import("./layouts/extra-layout/extra-layout.routes").then(
        (m) => m.EXTRA_ROUTES
      ),
  },
  {
    path: "index",
    loadComponent: () =>
      import("./pages/app/dashboard/dashboard.component").then(
        (m) => m.DashboardComponent
      ),
  },
];
